module.exports = __webpack_public_path__ + "static/media/Gravity-Regular.c5833b37.otf";